<template>
	 <div class="dynamiclist qualityenterprise"> 
				<leftnav class="fl" mkcode="B" itemcode="B-DTJC"></leftnav> 
				<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''"> 
					<govheader></govheader>
					<div class="index_left_centerpage">
						<div class="whitebox right_topbox" style="padding-bottom: 1px;">
							<div class="right_boxtitle">
								<span class="fl right_title">动态监测</span> 
							</div> 
					 <div class="opport-screen-list1"> 
					 	<dl class="opport-screen bdbe">
					 		<dt class="fl title">招商机会</dt>
					 		<dd class="fl">
					 			<span v-for="(item,index) in enterinarr" v-show="item.type!=0" @click="routerself(item.url);" :class="searchtype == item.curindex?'a-screen current':'a-screen'">{{item.name}}{{item.type}}</span>
					 		<!-- 	<el-tooltip class="item smartTip-text" effect="light" placement="top-start"><i	class="el-icon-question"style="color:cornflowerblue;margin-left: 5px;"></i>
					 				<div slot="content" class="list_tips">
					 					<p>上市公司：被批准在证券交易所上市交易的股份有限公司</p> 
					 				</div>
					 			</el-tooltip> -->
					 		</dd>
					 	</dl>
						<dl class="opport-screen bdbe">
							<dt class="fl">时间</dt>
							<dd class="fl">
								<span v-for="(item,index) in dayarry" @click="daychoose(item.key);" :class="timekey == item.key?'a-screen current':'a-screen'">{{item.name}}</span>
							</dd>
						</dl> 
					 <div class="eninvest_list_screen oh">
							<h5 class="fl title">企业名称</h5>
							<div class="fl">
								<el-select v-model="stockChiness" placeholder="全部" @change="getEnterpriseName"><el-option  v-for="item in enterpriseOption"  :key="item.id"  :label="item.title"   :value="item.title"> </el-option> </el-select>
							</div>
							<span class="basebtn"@click="routerlinkid('/enterpirseinvestEdit')">添加企业</span>
						</div>
					</div>
				</div>
				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" >产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果投资动态</p> 
					</div>
					<div class="enterprise_list_box" >
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>行政区</th>
								<th>项目名称</th> 
								<th>总面积(亩)</th>
								<th>土地用途</th>
								<th style="line-height: 20px;padding:10px 0; ">土地使用权人<br/>(项目公司)</th>
								<th>投资主体</th>
								<th>投资来源地</th> 
								<th>签订日期</th> 
							</tr>
							<tr v-for="(list,index) in enterpristlist">
								<td>{{index+1}}</td>
								<td>{{list.area}}</td>
								<td style="width: 200px;">{{list.projectName}}</td>
								<td>{{list.size}}{{list.sizeUnit}}</td>
								<td>{{list.purpose}}</td>
								<td>
									<span class="curp" v-if="list.stockCode!=''"  @click="routerlinkid('/enterprises',list.stockCode)">{{list.owner}}</span>
									<span v-if="list.stockCode==''">{{list.owner}}</span> 
								</td>
							<td>
								<span class="curp" v-if="list.sourceStockCode!=''"  @click="routerlinkid('/enterprises',list.sourceStockCode)">{{list.sourceEnterprise}}</span>
								<span v-if="list.sourceStockCode==''">{{list.sourceEnterprise}}</span> 
							</td>
								<td>{{list.sourceArea}}</td>
								<td>{{list.time}}</td> 
							</tr> 
						</table>
					</div> 
					<!-- <div class="centerpage1 company_pagelist" v-show="totalPage>0">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div> -->
				</div> 
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'investDynamic',
		data: function(){
			return{
		  userdata:{},curWebsite:this.$api.getWebsiteType(),  	title: '企业投资动态',	searchPlaceholder:'检索企业投资动态列表',
				searchtype:3,  
				enterinarr: [
					{curindex: 1,type: 9,name: "投资项目动态",tagnum:10010,url:"/investdynamic"},
					{curindex: 2,type: 1,name: "拿地项目动态",tagnum:10010,url:"/landdynamic"},
					{curindex: 3,type: 2,name: "企业投资动态",tagnum:3,url:"/enterpriseInvestdynamic"}, 
					{curindex: 4,type: 3,name: "招商情报实时动态",tagnum:10009,url:"/timeinfor"},   
				],
				enterpriseOption:[],
				dayarry:[{name:"本月",key:"month"},{name:'本周',key:"week"},{name:"本日",key:"day"}],
				stockChiness:'全部', searchstockCode:'all',
				timekey:'month', 
				enterpristlist:[], 
					total: 0, //记录总数
				// page: 1, //显示的是哪一页
				// haspage: true, //是否还有下一页
				// pageSize: 10, //每一页显示的数据条数 
				// totalPage: 1,
				// maxPage: 10, //最大页数 
			};
		},
		created() { 
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
				this.userdata = this.getuseriformation();
				this.enterinarr[3].name=this.curWebsite.type== 4?'市场情报动态':'招商情报动态';
				this.enterinarr[2].name=this.curWebsite.type== 4?0:2;
				// this.bus.$emit('loading', true);
		},
	 
		mounted() {
		// this.gethotindustry(); 
		if(this.userdata.edition<1){
			var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function(){
				_this.routerself('/totalEnterprises');
			},1000)
			return;
		}
		this.bus.$emit('loading', true);
		this.getenterOption();
		this.getdynamiclist();
		},
		methods:{
			//时间筛选
			daychoose(key){
				this.timekey=key;
				this.getdynamiclist();
			}, 
			//获取用户设置的企业列表数据
			getenterOption(){ 
				var _this=this;
				var ajaxurl=this.$api.cyl.userenterprise.list();
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log(ajaxurl)
					// console.log('获取用户设置的企业列表数据',res.data.list)
					if (res.data.success) {
						_this.enterpriseOption=res.data.list; 
						_this.enterpriseOption.unshift({id:0,title:'全部',stockCode:"all"})
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//点击设置当前搜索名字
			getEnterpriseName(val){
				console.log(val);
				var _this=this;
				this.enterpriseOption.forEach(list=>{
					if(list.title == val){
						_this.searchstockCode=list.stockCode;
						_this.getdynamiclist();
						return;
					}
				})
			},
		//获取动态列表
		getdynamiclist(page){
			this.bus.$emit('loading', true);
			if(!page){
				page=1;this.page=1;
			}  
		 
			var timeja =this.splicing('date',this.timekey);
			var _this=this;
			var ajaxurl=this.$api.enterpriseapi.land.enterpriseinvest()+'?stockCode='+_this.searchstockCode+timeja ;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function(res) {
				console.log(ajaxurl)
				console.log('获取动态列表',res.data)
				if (res.data.success) {
					_this.enterpristlist=res.data.list;
					 _this.total = res.data.list.length;
					_this.bus.$emit('loading', false); 
				} else {
					
				}
			}).catch(function(error) {
				// 请求失败处理 console.log(error);
			});
		},
		//搜索关键词
		searchkwfun() {
			this.searchtext = $.trim(this.searchtext);
			// if(this.searchtext!="" || ){
			this.getdynamiclist();
			// } 
		},
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchkwfun();
			}
		},
		pageHandler: function(page) {
			this.page = page;
			this.getdynamiclist(page);
		}, 
		}
	}
</script>

<style>
	.a-red{
		color:#c00;
	}
	.right_boxtitle .el-tooltip{
		position: relative;top: 10px;
	}
</style>